import { useAuth } from 'react-oidc-context';

import { authService } from 'src/services/auths/authService';
import type { AuthentificatedUser } from 'src/types/domain/AuthentificatedUser';

export function useUser(): {
  user: AuthentificatedUser | null;
} {
  const { user } = useAuth();
  const fullUser = user ? authService.formatSsoUser(user) : null;

  return { user: fullUser };
}
